module.exports = __webpack_public_path__ + "static/images/monet/survey_drag_element.png";